'use client';

import { NavigationMenu } from '@base-ui/react/navigation-menu';

import { Backdrop } from '@libs/shared-ui';

import type { PrimaryNavigationItem } from '../../../types';
import { DropdownPanel } from './dropdown-panel';
import { NavigationItem } from './navigation-item';
import { useDesktopMenu } from './use-desktop-menu';

import './desktop-menu.scss';

const MENU_OPEN_DELAY_MS = 100;

type DesktopMenuProps = {
    items: PrimaryNavigationItem[];
};

export function DesktopMenu({ items }: DesktopMenuProps) {
    const { closeMenu, openMenu, portalContainer, setNavigationRoot, setOpenMenu } = useDesktopMenu();

    return (
        <NavigationMenu.Root
            delay={MENU_OPEN_DELAY_MS}
            value={openMenu}
            onValueChange={setOpenMenu}
            render={<nav ref={setNavigationRoot} className="desktop-menu" />}
        >
            <NavigationMenu.List className="desktop-menu__list">
                {items.map(item => (
                    <NavigationItem key={item.id} item={item} onKeyboardClose={closeMenu}>
                        {item.kind !== 'link' && (
                            <NavigationMenu.Content className="desktop-menu__content">
                                <DropdownPanel item={item} />
                            </NavigationMenu.Content>
                        )}
                    </NavigationItem>
                ))}
            </NavigationMenu.List>

            {portalContainer && (
                <NavigationMenu.Portal container={portalContainer}>
                    <NavigationMenu.Positioner
                        align="start"
                        collisionPadding={0}
                        positionMethod="absolute"
                        sideOffset={16}
                        className="desktop-menu__positioner"
                    >
                        <NavigationMenu.Backdrop render={<Backdrop className="desktop-menu__backdrop" />} />
                        <NavigationMenu.Popup className="desktop-menu__popup">
                            <NavigationMenu.Viewport className="desktop-menu__viewport" />
                        </NavigationMenu.Popup>
                    </NavigationMenu.Positioner>
                </NavigationMenu.Portal>
            )}
        </NavigationMenu.Root>
    );
}
